import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionService } from 'src/app/services/session.service';
import { environment } from 'src/environments/environment';
import { IRegionalEcosystemStatusModel, ICategoryPurposeRegionalEcosystemStatusModel, IRegionalEcosystemStatusesResponseModel } from '../models/veg-wizard-models';

@Injectable({
  providedIn: 'root'
})
export class RegionalEcosystemStatusService {

  constructor(
    protected http: HttpClient,
    private sessionService: SessionService) {
  }

  getAvailableRegionalEcosystemStatuses$(): Observable<ICategoryPurposeRegionalEcosystemStatusModel[]> {
    const url = `${environment.apiUrl}/session/${encodeURIComponent(this.sessionService.getSessionId() ?? '')}/available-regional-ecosystem-statuses`;

    return this.http.get<ICategoryPurposeRegionalEcosystemStatusModel[]>(url);
  }

  setRegionalEcosystemStatuses$(model: IRegionalEcosystemStatusModel): Observable<IRegionalEcosystemStatusesResponseModel> {
    const url = `${environment.apiUrl}/session/${encodeURIComponent(this.sessionService.getSessionId() ?? '')}/regional-ecosystem-statuses`;

    return this.http.post<IRegionalEcosystemStatusesResponseModel>(url, model);
  }
}
